// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__0NW60","error":"NotFoundPage_error__JMXfJ","text":"NotFoundPage_text__4i67U"};